import { colors } from "Constants";

export const previewModeStyles = {
  listItemStyle: {
    flexBasis: "unset",
    borderBottom: `1px solid ${colors.borderSubtle}`,
    paddingBottom: "12px",
    margin: "0",
  },
  checklistContainerStyle: {
    flex: 1,
    flexDirection: "column",
    gap: "20px",
  },
  checkBoxLabelStyles: {
    wordBreak: "break-word",
  },
};

export const editModeStyles = {
  listItemStyle: {
    flexBasis: "unset",
    borderBottom: `1px solid ${colors.borderSubtle}`,
    paddingBottom: "12px",
  },
  checklistContainerStyle: {
    flex: 1,
    flexDirection: "column",
  },
  checkBoxLabelStyles: {
    wordBreak: "break-word",
  },
};

export const emptyLabelStyle = {
  color: colors.red52,
};
